import { createAppWrap } from '../../create_app_wrap';
import mixin from './_mixin';
import modalCategoryEdit from '../../components/category/_modal_category_edit';
import categoryEdit from '../../components/category/_category_edit';
import templateSelecter from '../../components/_template_selecter';
import modalStoreCategoryReset from '../../components/category/_modal_store_category_reset';

const view = '[data-view="item-new"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // カテゴリ入力欄
                add_category_name: '',
                // 選択済パス一覧
                path_config: [],
                // カテゴリデータ一覧
                categories: [],
                // デザイン設定画面
                disp_design_edit: false,
            };
        },
        /**
         * コンポーネント群
         */
        components: {
            // カテゴリ管理コンポーネント
            'category': modalCategoryEdit,
            // カテゴリ編集コンポーネント新規page_keyを取得する為に使用
            'category-edit': categoryEdit,
            // テンプレート選択コンポーネント
            'template-selecter': templateSelecter,
            // カテゴリリセット確認モーダル
            'modal-store-category-reset' : modalStoreCategoryReset,
        },
        mixins: [
            mixin,
        ],
        computed: {
            // 表示ステップ番号
            step: {
                get() {
                    // デザイン設定画面
                    if (this.disp_design_edit) {
                        return 4;
                    }
                    // 商品データがセットされたら
                    if (Object.keys(this.item_data).length > 0) {
                        return 3;
                    }
                    // パスがセットされたら、もしくはadminだったら
                    if (this.path_config.length || this.isAdmin) {
                        return 2;
                    }
                    return 1;
                },
                set(value) {
                    this.disp_design_edit = (value === 4);
                    if (value <= 2) {
                        this.item_data = {};
                    }
                    if (value <= 1) {
                        this.templates = {};
                        this.path_config = [];
                        this.add_category_name = '';
                    }
                },
            },
            // テンプレート取得ボタンが押せる状態か
            canGetTemplates: function () {
                if (this.path_config.length > 0 || this.add_category_name.length > 0) {
                    return true;
                }
                return false;
            },
        },
        watch: {
            // パスがセットされたら
            path_config: function (newValue, oldValue) {
                if (newValue.length > 0 && oldValue.length === 0) {
                    // カテゴリリストをセット
                    this.categories = this.$refs.firstCategorySelect.getCategories();
                    if (Object.keys(this.categories).length > 0) {
                        this.$refs.updateCategoryConfirm.setCategories(this.categories);
                    }
                }
            }
        },
        methods: {
            // ヤフーTOKEN認証チェック後に初回実行処理
            isValidToken: async function (boolean) {
                if (!boolean) {
                    return;
                }

                const params = this.$_params();
                if (typeof params.id !== 'undefined') {
                    // 通常下書き取得
                    if (typeof params.copy === 'undefined') {
                        this.setEditId(params.id);
                        await this.setDraftItem(params.id);
                    // コピー
                    } else {
                        // 下書きのコピー
                        if (params.copy === 'draft') {
                            await this.setDraftItem(params.id, this.edit_id);
                        }
                        // 公開データのコピー
                        if (params.copy === 'released') {
                            await this.setItemData(params.id, 1);
                        }
                        // 商品コードを空、商品名に(コピーの文言付与)
                        this.item_data.item_code = '';
                        this.item_data.name = this.item_data.name + '(コピー)';
                    }
                    return;
                }
                // 初回、adminでなければカテゴリ選択モーダルを開く
                if (typeof params.first_create === 'undefined' && !this.isAdmin) {
                    this.$refs.firstCategorySelect.show();
                    return;
                }
            },
            // 入力したカテゴリをパス化する
            addCategoryNameToPath: async function (event) {
                // カスタムバリデーションセット
                if (/テスト|test/.test(this.add_category_name)) {
                    this.$refs.addCategoryName.setCustomValidity('「テスト test」の文字は使用できません');
                }
                // HTML5のバリデーションエラーの場合はそのままフォーム送信する
                if (!event?.target?.form?.checkValidity()) {
                    return;
                }
                event.preventDefault();

                const name = this.add_category_name;
                let pageKey = null;
                let addIndex = null;
                let order = 1;
                // カテゴリリストを取得
                let categories = this.$refs.firstCategorySelect.getCategories();

                // 最上位に対象カテゴリがあればkeyを返す
                for (const i in categories) {
                    let category = categories[i];
                    if (category.depth === 1) {
                        if (category.name === name) {
                            pageKey = category.page_key;
                        }
                        order++;
                        addIndex = i;
                    }
                }
                // なかったら新規で最上位にカテゴリ追加してkeyを返す
                if (!pageKey) {
                    // カテゴリ追加
                    let params = this.createParams(name, order);
                    pageKey = await this.$refs.getPageKey.saveAndGetPageKey(name, params, false);
                    // 全カテゴリリスト更新
                    if (pageKey) {
                        params.page_key = pageKey;
                        categories.splice(addIndex + 1, 0, params);
                        // カテゴリ一覧を更新
                        this.$refs.firstCategorySelect.setCategories(categories);
                    }
                }
                // パス追加
                if (pageKey) {
                    this.path_config = [pageKey];
                }
            },
            // 新カテゴリデータ生成
            createParams: function (name, order) {
                return {
                    name: name,
                    page_key: null,
                    parent_page_key: null,
                    depth: 1,
                    order: order,
                };
            },
            // プレビューを表示
            showPreview: function (template) {
                // パスをマージ
                template.data.path_config = this.path_config;
                this.$refs.preview.show(template.title, template.data);
            },
            // 商品情報入力画面へ
            gotoEdit: function (template) {
                // パスをマージ
                template.path_config = this.path_config;
                // 商品データセット
                this.item_data = template;
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
